import axios from '@/plugins/axios'

const BASE = 'enriquecimento'

export async function listarLayouts() {
  const { data } = await axios.get(`${BASE}/layouts`)
  return data
}

export async function listarStatus() {
  const { data } = await axios.get(`${BASE}/status`)
  return data
}

export async function listarLotes(ultimosDias = 7) {
  const { data } = await axios.get(`${BASE}/lotes`, {
    params: { ultimosDias },
  })
  return data
}

export async function obterLote(id) {
  const { data } = await axios.get(`${BASE}/lotes/${encodeURIComponent(id)}`)
  return data
}

export async function aprovarLote(id, body = {}) {
  const { data } = await axios.post(
    `${BASE}/lotes/${encodeURIComponent(id)}/aprovar`,
    body,
  )
  return data
}

export async function retornoLote(id) {
  const { data } = await axios.get(
    `${BASE}/lotes/${encodeURIComponent(id)}/retorno`,
  )
  return data
}

export async function uploadLote({ file, nomearquivo, idlayout }) {
  const form = new FormData()
  form.append('file', file)
  form.append('nomearquivo', nomearquivo)
  form.append('idlayout', String(idlayout))

  const { data } = await axios.post(`${BASE}/upload`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}
